import styled, { css } from 'styled-components';

export const Action = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.element.primary};
  padding: 10px 12px;
  height: 45px;
  width: 100%;
  cursor: pointer;
  transition: 0.5s;
  :hover {
    background-color: ${(props) => props.theme.colors.brand.secondaryAlt};
    color: ${(props) => props.theme.colors.brand.primary};
  }

  ${({ type }) =>
    type === 'link' &&
    css`
      display: inline;
      padding: 0;
      height: auto;
      width: auto;
      :hover {
        background-color: transparent;
        color: transparent;
      }
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;

      &:hover {
        background-color: ${({ theme }) => theme.colors.background.primary};
        color: ${({ theme }) => theme.colors.element.primary};
      }
    `};
`;

export const ActionInfo = styled.div`
  display: flex;
  align-items: ${(props) => (props.subActions ? 'start' : 'center')};
  line-height: 15px;
  width: 100%;

  ${({ type }) =>
    type === 'link' &&
    css`
      display: inline;
      color: ${({ theme }) => theme.colors.brand.primary};
      text-decoration: underline;
    `};
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.element.secondary};
`;
